import React from 'react';
import PropTypes from 'prop-types';
import ReactPaginate from 'react-paginate';
import { useTranslation } from 'react-i18next';
import './_styles_/Paginator.css';

Paginator.propTypes = {
    totalCount: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    currentPage: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    top: PropTypes.bool,
    bottom: PropTypes.bool,
};

Paginator.defaultProps = {
    top: false,
    bottom: false,
};

function Paginator(props) {
    const {
        totalCount,
        perPage,
        currentPage,
        onPageChange,
        children,
        top,
        bottom,
    } = props;
    const { t } = useTranslation();
    const pageCount = Math.ceil(totalCount / perPage);
    const isVisible = pageCount > 1;
    const pageChangeHandler = (data) => {
        onPageChange(data.selected);
    };
    const reactPaginate = (
        <ReactPaginate
            pageCount={pageCount}
            pageRangeDisplayed={5}
            marginPagesDisplayed={5}
            initialPage={currentPage}
            forcePage={currentPage}
            previousLabel="&laquo;"
            previousAriaLabel={t('misc.previous-page')}
            nextLabel="&raquo;"
            nextAriaLabel={t('misc.next-page')}
            containerClassName="pagination"
            pageLinkClassName="page-link"
            activeLinkClassName="active-page-link"
            previousLinkClassName="previous-link"
            nextLinkClassName="next-link"
            breakLinkClassName="break-link"
            onPageChange={pageChangeHandler}
            disableInitialCallback
        />
    );
    return (
        <>
            {top && isVisible && reactPaginate}
            {children}
            {bottom && isVisible && reactPaginate}
        </>
    );
}

export default Paginator;
